import {applySpec, flow, map, stubString, toDefaultEmptyString} from '@logistics-frontend/utils'

import type {Offer} from '../../../model/offer'
import type {OffersCalculateResponse} from '../../../repo/dcaa'
import {offerGetter, offersCalculateGetter} from '../../../repo/dcaa/getters/offers-calculate-getter'

const getOffers = offersCalculateGetter('claims_offers')

const getId = offerGetter('payload')
const getPrice = offerGetter('price.total_price')
const getPriceVAT = offerGetter('price.total_price_with_vat')
const getSurgeRatio = offerGetter('price.surge_ratio')
const getDisableReason = offerGetter('filter_reason.message')
const getDisableReasonCode = offerGetter('filter_reason.code')
const getCurrency = offerGetter('price.currency')
const getVisitingIntervals = offerGetter('visiting_intervals')

// @ts-expect-error - типы старые. Формат ручки поменялся.
const getTariff = offerGetter('tariff_info.tariff')
// @ts-expect-error - типы старые. Формат ручки поменялся.
const getVertical = offerGetter('tariff_info.vertical')
// @ts-expect-error - типы старые. Формат ручки поменялся.
const getTitle = flow(offerGetter('tariff_info.title'), toDefaultEmptyString)

const toOffer: (estimationResult: OffersCalculateResponse['claims_offers'][number]) => Offer = applySpec<Offer>({
  id: getId,
  title: getTitle,
  price: getPrice,
  priceVAT: getPriceVAT,
  surgeRatio: getSurgeRatio,
  tariff: getTariff,
  disableReason: getDisableReason,
  disableReasonCode: getDisableReasonCode,
  currency: getCurrency,
  vertical: getVertical,
  visitingIntervals: getVisitingIntervals,
  intervalCaption: stubString,
})

export const fromOffersCalculateResponse: (response: OffersCalculateResponse) => Array<Offer> = flow(
  getOffers,
  map(toOffer),
)
